import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ReducerState } from '../../reducers';
import { useConfig } from '../../default-config';
import { StringObject } from  '../../types';

/** ************************************************************************
 ************************************************************************* */
export const usePrevious = (value: any): any => {
 	const reference = useRef<any>(null);
 	useEffect(() => {
   		reference.current = value;
  	}, [value]);
  	return reference.current;
};

/** ************************************************************************
 ************************************************************************* */
export const useTranslation = (): StringObject => {
    const { siteLang, texts } = useConfig();
    return texts[siteLang] || texts.nb || {};
};

/** ************************************************************************
 ************************************************************************* */
export const useActivation = () => {
    return useSelector((appState: ReducerState) => appState.activation);
};

/** ************************************************************************
 ************************************************************************* */
export const useOverview = () => {
    return useSelector((appState: ReducerState) => appState.overview);
};